export const getNormalizedFilter = (rawFilter: any) => {
    return typeof rawFilter === 'object' ? (rawFilter ?? {}) : {};
};

export const getStatusesFilter = <T extends Record<string, boolean>>(
    filterSettings: Record<number, keyof T>,
    statuses?: number[],
    enabledSettings?: T
): number[] => {
    if (statuses && statuses.length > 0) {
        return statuses;
    }

    return getEnabledSettingStatuses(filterSettings, enabledSettings);
};

export const getEnabledSettingStatuses = <T extends Record<string, boolean>>(
    filterSettings: Record<number, keyof T>,
    enabledSettings?: T
): number[] => {
    let keys = Object.keys(filterSettings).map(key => Number(key));
    keys = keys.filter((status: number) => {
        if (filterSettings[status]) {
            let settingEnabled = true;
            if (enabledSettings) {
                settingEnabled = enabledSettings[filterSettings[status]!];
            }
            return settingEnabled;
        }
        return false;
    });
    return keys;
};
